import React from "react";
import { Box, Paper, useTheme } from "@mui/material";

export type PanelSurfaceProps = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  fill?: boolean;
  "aria-label"?: string;
};

export function PanelSurface({ header, footer, children, fill = true, "aria-label": ariaLabel }: PanelSurfaceProps) {
  const theme = useTheme();

  return (
    <Paper
      component={ariaLabel ? "section" : "div"}
      role={ariaLabel ? "region" : undefined}
      aria-label={ariaLabel}
      variant="outlined"
      sx={{
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        ...(fill && {
          height: "100%",
          minHeight: 0,
          flex: 1,
        }),
      }}
    >
      {header != null ? (
        <Box
          sx={{
            flexShrink: 0,
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        >
          {header}
        </Box>
      ) : null}

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
        }}
      >
        {children}
      </Box>

      {footer != null ? (
        <Box
          sx={{
            flexShrink: 0,
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          {footer}
        </Box>
      ) : null}
    </Paper>
  );
}